export default {
  title: "",
  startsAt: "",
  endsAt: "",
  approbated: false,
  categoryId: "",
  organizerId: "",
  rangeId: ""
}
